export const SET_RECEIPTS = 'SET_RECEIPTS';
export const setReceipts = (receipts) => ({
    type: SET_RECEIPTS,
    receipts
});